var Global = {
  url: "https://back.saborgrafico.com.ar/api/"
};

export default Global;
